export default function () {
  "use strict";

  applyStickyDynamism();

  let navbarToggler = document.querySelector("#navbarToggler");
  const navbarCollapse = document.querySelector("#navbarCollapse");

  navbarToggler.addEventListener("click", () => {
    navbarToggler.classList.toggle("navbarTogglerActive");
    navbarCollapse.classList.toggle("hidden");
  });

  document
    .querySelectorAll("#navbarCollapse ul li:not(.submenu-item) a")
    .forEach((e) =>
      e.addEventListener("click", () => {
        navbarToggler.classList.remove("navbarTogglerActive");
        navbarCollapse.classList.add("hidden");
      })
    );
  const submenuItems = document.querySelectorAll(".submenu-item");
  submenuItems.forEach((el) => {
    el.querySelector("a").addEventListener("click", () => {
      el.querySelector(".submenu").classList.toggle("hidden");
    });
  });

  const wow = new WOW({
    live: false
  });

  wow.init();

  const toTop = document.querySelector(".back-to-top");
    toTop.addEventListener("click", () => {
      scrollTo(document.documentElement);
    });

  //window.document.addEventListener("scroll", onScrollHighlightCorrectMenu);
  window.document.addEventListener("scroll", () => {
    debounce(onScrollHighlightCorrectMenu, 90);
    // wow.sync();
  });
}

function debounce(method, delay) {
  clearTimeout(method._tId);
  method._tId= setTimeout(function(){
      method();
  }, delay);
}

function scrollTo(element, to = 0, duration = 500) {
  const start = element.scrollTop;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;

  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };


  const animateScroll = () => {
    currentTime += increment;

    const val = Math.easeInOutQuad(currentTime, start, change, duration);

    element.scrollTop = val;

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };

  animateScroll();
}

function onScrollHighlightCorrectMenu(e) {
  const sections = document.querySelectorAll(".ud-menu-scroll");
  const scrollPos =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;

  if (!sections) return;

  for (let i = 0; i < sections.length; i++) {
    const currLink = sections[i].querySelector("a");
    const val = currLink.getAttribute("href");
    const refElement = document.querySelector(val);
    const scrollTopMinus = scrollPos + 70;

    if (!refElement) continue;
    if (scrollPos === 0 || scrollTopMinus < 80) {
      sections[i].classList.remove("active");
      continue;
    }
    if (
      refElement.offsetTop <= scrollTopMinus &&
      refElement.offsetTop + refElement.offsetHeight > scrollTopMinus
    ) {
      document.querySelector(".ud-menu-scroll").classList.remove("active");
      sections[i].classList.add("active");
    } else {
      sections[i].classList.remove("active");
    }
  }
}

function applyStickyDynamism() {
  window.onscroll = function () {
    const ud_header = document.querySelector(".ud-header");
    const sticky = ud_header.offsetTop;
    const logo = document.querySelector(".header-logo");

    if (window.pageYOffset > sticky) {
      ud_header.classList.add("sticky");
    } else {
      ud_header.classList.remove("sticky");
    }

    // === logo change
    logo.src = require("@/assets/images/logo.png");
    // if (ud_header.classList.contains("sticky")) {
    //   logo.src = require("@/assets/images/logo.png");
    // } else {
    //   logo.src = require("@/assets/images/logo-dark.png");
    // }

    // show or hide the back-top-top button
    const backToTop = document.querySelector(".back-to-top");
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      backToTop.style.display = "flex";
    } else {
      backToTop.style.display = "none";
    }
  };
}
